require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils")) : factory(root["./utils"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[51],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 451:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(452);


/***/ }),

/***/ 452:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _SearchInput = _interopRequireDefault(__webpack_require__(453));

exports["default"] = _SearchInput["default"];
exports.SearchInput = _SearchInput["default"];

/***/ }),

/***/ 453:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

var _interopRequireWildcard = __webpack_require__(2);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _baUiCarbon = __webpack_require__(12);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _utils = __webpack_require__(4);

var _SearchInput = _interopRequireDefault(__webpack_require__(454));

var _StringResource = _interopRequireDefault(__webpack_require__(456));

var _dec, _class, _class2, _temp;

var BaPropTypes = _utils.propsUtils.BaPropTypes;

var _CLASS = _SearchInput["default"].searchInputClassName.replace(/"/g, '');

var SearchInput = (_dec = (0, _utils.debounceInput)(), _dec(_class = (_temp = _class2 = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(SearchInput, _Component);

  function SearchInput(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (carbonSearchInput) {
      _this._input = carbonSearchInput == null ? void 0 : carbonSearchInput.input;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onClear = _this$props.onClear; // this really really needs to get done(switch to native onChange behaviour)

      onChange && onChange(e.target.value, e); // this is a clear event

      onClear && e.type !== 'change' && onClear();
    });
    return _this;
  }

  var _proto = SearchInput.prototype;

  _proto.focus = function focus() {
    this._input && this._input.focus();
  };

  _proto.render = function render() {
    var _ref;

    var _this$props2 = this.props,
        placeHolderText = _this$props2.placeHolderText,
        placeholder = _this$props2.placeholder,
        expanded = _this$props2.expanded,
        open = _this$props2.open,
        icon = _this$props2.icon,
        iconLeft = _this$props2.iconLeft,
        iconRight = _this$props2.iconRight,
        hideLeftIcon = _this$props2.hideLeftIcon,
        className = _this$props2.className,
        style = _this$props2.style,
        _this$props2$dataTid = _this$props2['data-tid'],
        datatid = _this$props2$dataTid === void 0 ? _CLASS : _this$props2$dataTid,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props2, ["placeHolderText", "placeholder", "expanded", "open", "icon", "iconLeft", "iconRight", "hideLeftIcon", "className", "style", "data-tid"]);
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _CLASS + " " + className,
      style: style,
      "data-tid": datatid
    }, /*#__PURE__*/_react["default"].createElement(_baUiCarbon.Search, (0, _extends2["default"])({}, others, {
      ref: this._ref,
      onChange: this._onChange,
      closeButtonLabelText: _StringResource["default"].get('clear') // text for the clear(X) icon
      ,
      placeHolderText: (_ref = placeHolderText != null ? placeHolderText : placeholder) != null ? _ref : undefined
    })));
  };

  return SearchInput;
}(_react.Component), (0, _defineProperty2["default"])(_class2, "propTypes", (0, _extends2["default"])({}, _baUiCarbon.Search.propTypes, {
  value: _propTypes["default"].string,
  onClear: _propTypes["default"].func,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  placeHolderText: _propTypes["default"].string,

  /** deprecated: not applicable to carbon */
  placeholder: BaPropTypes.deprecated('deprecated: use placeHolderText'),

  /** deprecated: not applicable to carbon */
  expanded: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  open: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  icon: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconLeft: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  iconRight: BaPropTypes.deprecated('deprecated: not applicable to carbon'),

  /** deprecated: not applicable to carbon */
  hideLeftIcon: BaPropTypes.deprecated('deprecated: not applicable to carbon')
})), (0, _defineProperty2["default"])(_class2, "defaultProps", {
  className: '',
  style: {}
}), _temp)) || _class);
exports["default"] = SearchInput;

/***/ }),

/***/ 454:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(455);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 455:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, "\n", ""]);

// exports
exports.locals = {
	"searchInputClassName": "\"ba-common-searchInput\""
};

/***/ }),

/***/ 456:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _SearchInputResources = _interopRequireDefault(__webpack_require__(457));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_SearchInputResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

var amdi18n={"__root":{"clear":"Clear"},"__cs":{"clear":"Vymazat"},"__da":{"clear":"Ryd"},"__de":{"clear":"Aufheben"},"__es":{"clear":"Borrar"},"__fi":{"clear":"Tyhjennä"},"__fr":{"clear":"Effacer"},"__hr":{"clear":"Isprazni"},"__hu":{"clear":"Törlés"},"__it":{"clear":"Annulla"},"__ja":{"clear":"クリア"},"__kk":{"clear":"Тазалау"},"__ko":{"clear":"지우기"},"__nb":{"clear":"Fjern"},"__nl":{"clear":"Verwijderen"},"__no":{"clear":"Fjern"},"__pl":{"clear":"Wyczyść"},"__pt":{"clear":"Limpar"},"__pt-br":{"clear":"Limpar"},"__ro":{"clear":"Curăţare"},"__ru":{"clear":"Очистить"},"__sl":{"clear":"Počisti"},"__sv":{"clear":"Radera"},"__th":{"clear":"เคลียร์"},"__tr":{"clear":"Temizle"},"__zh":{"clear":"清除"},"__zh-cn":{"clear":"清除"},"__zh-hk":{"clear":"清除"},"__zh-mo":{"clear":"清除"},"__zh-sg":{"clear":"清除"},"__zh-tw":{"clear":"清除"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[451,0]]]);
});